import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

import Iconify from "components/iconify";
import { useTranslation } from "i18n";
import "./style.css";

const BAGGAGE_OPTIONS = [
  {
    value: "2x Checked baggage",
    labelKey: "filters.twoCheckedBaggage",
    descriptionKey: "noBaggageModal.twoBagsDescription",
    icon: "mdi:bag-suitcase",
    recommended: true,
  },
  {
    value: "Checked baggage",
    labelKey: "filters.checkedBaggage",
    descriptionKey: "noBaggageModal.oneBagDescription",
    icon: "mdi:bag-suitcase-outline",
  },
];

const NoBaggageModal = ({
  open,
  onClose,
  onContinue,
  onApplyBaggageFilter,
}) => {
  const { t } = useTranslation();

  const handleSelectFilter = (optionValue) => {
    onApplyBaggageFilter?.(optionValue);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="no-baggage-modal-title"
      aria-describedby="no-baggage-modal-description"
    >
      <Box className="no-baggage-modal" tabIndex={-1}>
        <div className="no-baggage-modal__glow" />
        <IconButton
          className="no-baggage-modal__close"
          onClick={onClose}
          aria-label="Close"
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <div className="no-baggage-modal__content">
          <div className="no-baggage-modal__hero">
            <span className="no-baggage-modal__icon" aria-hidden="true">
              <Iconify icon="mdi:bag-suitcase-off-outline" width={28} />
            </span>
            <h2 id="no-baggage-modal-title" className="no-baggage-modal__title">
              {t("noBaggageModal.title")}
            </h2>
            <p
              id="no-baggage-modal-description"
              className="no-baggage-modal__subtitle"
            >
              {t("noBaggageModal.description")}
            </p>
          </div>

          <p className="no-baggage-modal__section-label">
            {t("noBaggageModal.sectionLabel")}
          </p>

          <div className="no-baggage-modal__options">
            {BAGGAGE_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`no-baggage-modal__option${
                  option.recommended ? " is-recommended" : ""
                }`}
                onClick={() => handleSelectFilter(option.value)}
              >
                <span className="no-baggage-modal__option-icon-wrap">
                  <Iconify icon={option.icon} width={22} />
                </span>
                <span className="no-baggage-modal__option-copy">
                  <span className="no-baggage-modal__option-heading">
                    <span className="no-baggage-modal__option-label">
                      {t(option.labelKey)}
                    </span>
                    {option.recommended && (
                      <span className="no-baggage-modal__badge">
                        {t("noBaggageModal.recommended")}
                      </span>
                    )}
                  </span>
                  <span className="no-baggage-modal__option-text">
                    {t(option.descriptionKey)}
                  </span>
                </span>
                <Iconify
                  icon="mdi:chevron-right"
                  width={22}
                  className="no-baggage-modal__option-chevron"
                />
              </button>
            ))}
          </div>

          <button
            type="button"
            className="no-baggage-modal__continue"
            onClick={onContinue}
          >
            {t("noBaggageModal.continue")}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default NoBaggageModal;
